import SectorEnemyArt from './SectorEnemyArt';
import './SectorEncounters.css';
import { getSectorMinion } from './sectorEnemies';
import { getSectorJourney } from './sectorJourney';
import HealthLossFragments from './HealthLossFragments';

export const SectorSignal = ({ sector }) => {
  const enemy = getSectorMinion(sector);
  const journey = getSectorJourney(sector);
  return (
    <div
      className="coreboundSectorSignal"
      style={{ '--enemy-color': enemy.color }}
    >
      <SectorEnemyArt enemy={enemy} />
      <p>
        <strong>
          SECTOR {String(sector).padStart(2, '0')} / {enemy.name.toUpperCase()}
        </strong>
        <span className="coreboundSectorJourneyName">{journey.name}</span>
        {journey.story}
      </p>
    </div>
  );
};

const SectorEnemy = ({
  enemy,
  hp,
  maxHp = hp,
  training = false,
  board = false,
  showArt = true,
  reduceMotion = false,
}) => (
  <div
    className={
      'coreboundSectorEnemy ' +
      (board ? 'is-board' : '') +
      (training ? ' is-training' : '')
    }
    style={{ '--enemy-color': enemy.color }}
    aria-label={
      training
        ? enemy.name + ' training projection'
        : enemy.name + ', ' + hp + ' HP'
    }
  >
    {showArt && <SectorEnemyArt enemy={enemy} />}
    <div className="coreboundEnemyReadout">
      <small>
        {training ? 'BREACH TRAINING PROJECTION' : 'CORE SIGNAL DETECTED'}
      </small>
      <strong>{enemy.name}</strong>
      {training ? (
        <span>Safe practice · no retaliation</span>
      ) : (
        <>
          <span>
            {hp} / {maxHp}
            <span className="coreboundEnemyHealthUnit"> HP</span>
          </span>
          <div
            className="coreboundEnemyHealth"
            role="progressbar"
            aria-label={enemy.name + ' HP'}
            aria-valuenow={hp}
            aria-valuemin={0}
            aria-valuemax={maxHp}
          >
            <HealthLossFragments hp={hp} maxHp={maxHp} reduceMotion={reduceMotion} />
            <i
              style={{
                width: Math.max(0, Math.min(100, (hp / maxHp) * 100)) + '%',
              }}
            />
          </div>
        </>
      )}
    </div>
  </div>
);

export default SectorEnemy;
